var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.handsFreeText
      ? _c("div", { staticClass: "bg-gray2 mt-1" }, [
          _c("div", { staticClass: "container-fluid" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-12 pt-1" }, [
                _c("p", { staticClass: "d-flex align-items-center mb-0" }, [
                  _c("span", {
                    staticClass: "item-icon icon-hands-free font-size-24 pe-1",
                    attrs: { "aria-hidden": "true" },
                  }),
                  _vm._v(" "),
                  _c("strong", {
                    domProps: { innerHTML: _vm._s(_vm.handsFreeText) },
                  }),
                ]),
              ]),
            ]),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "bg-gray2" }, [
      _c("div", { staticClass: "container-fluid px-lg-0" }, [
        _c(
          "div",
          { staticClass: "row bg-gray2 pt-1", attrs: { id: "mentions" } },
          [
            _c("div", { staticClass: "col-12 px-lg-2 pb-2" }, [
              _vm.legalMentionsTitle
                ? _c("button", {
                    staticClass: "ob1-link-arrow text-start",
                    attrs: {
                      id: "mention",
                      type: "button",
                      "data-bs-toggle": "collapse",
                      "aria-expanded": "true",
                      "data-bs-target": "#collapsed-text",
                      "aria-controls": "#collapsed-text",
                    },
                    domProps: { innerHTML: _vm._s(_vm.legalMentionsTitle) },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.legalMentionsText
                ? _c(
                    "div",
                    {
                      staticClass: "collapse show font-size-resp-12",
                      attrs: {
                        id: "collapsed-text",
                        "aria-labelledby": "mention",
                      },
                    },
                    [
                      _c("div", {
                        domProps: { innerHTML: _vm._s(_vm.legalMentionsText) },
                      }),
                    ]
                  )
                : _vm._e(),
            ]),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }